import pick from 'lodash/pick';

import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { createNewListing, getListingsByIds, getListingWithPrivateData, getUserEmail, conversations, chatMessages, manualTransactions, transactionLineItems, updateTransactionMetadata, requestDocPresentation, shareCredential, fetchRequestRecords, createCheckoutSession, getUserDetails, rfpFreeApplicationsUsed, saveConsent, fetchConsent, requestShareOtp, verifyShareOtp, getSharedProfile, requestProfileAccess, getOwnJobRfpListings, checkCustomerIntegrityCheckStatus, requestCredentialAccess, getCredentialAccessRequests, approveCredentialAccess, rejectCredentialAccess, resendCredentialAccessEmail, fetchPersonaRecords } from '../../util/api';
import { approvalPayload } from './credentialAccessApproval';
import { keyedSubmission } from './submissionKeys';
import * as log from '../../util/log';
import { denormalisedResponseEntities } from '../../util/data';
import {
  bookingTimeUnits,
  findNextBoundary,
  getStartOf,
  monthIdString,
  stringifyDateToISO8601,
} from '../../util/dates';
import {
  hasPermissionToInitiateTransactions,
  hasPermissionToViewData,
  isUserAuthorized,
} from '../../util/userHelpers';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../util/urlHelpers';
import { getProcess, isBookingProcessAlias } from '../../transactions/transaction';
import { fetchCurrentUserHasOrdersSuccess, fetchPersonaRecordsSuccess, fetchUserPersonaRecords, setProfileListing } from '../../ducks/user.duck';
import { withOwnPrivateData } from '../../util/withOwnPrivateData';
import { readShareVisit } from './shareVisitStore';
import { get, set, update } from 'lodash';
import { SHOW_LISTINGS_SUCCESS } from '../EditListingPage/EditListingPage.duck';
import { userTypeOf } from '../../util/userType';
import { fetchLinkPage, clearListingLinkPages } from '../../ducks/linkedContacts.duck';
import { showPostingListing } from '../../util/postingRead';
import { isPostingData } from '../../util/postingVisibilityValues';

const { UUID } = sdkTypes;
const MINUTE_IN_MS = 1000 * 60;

// Day-based time slots queries are cached for 1 minute.
const removeOutdatedDateData = timeSlotsForDate => {
  const now = new Date().getTime();
  const minuteAgo = now - MINUTE_IN_MS;
  return Object.fromEntries(
    Object.entries(timeSlotsForDate).filter(([dateId, data]) => {
      return data.fetchedAt && data.fetchedAt > minuteAgo;
    })
  );
};

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/ListingPage/SET_INITIAL_VALUES';

export const SHOW_LISTING_REQUEST = 'app/ListingPage/SHOW_LISTING_REQUEST';
export const SHOW_LISTING_ERROR = 'app/ListingPage/SHOW_LISTING_ERROR';

export const FETCH_REVIEWS_REQUEST = 'app/ListingPage/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/ListingPage/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/ListingPage/FETCH_REVIEWS_ERROR';

export const FETCH_MONTHLY_TIME_SLOTS_REQUEST = 'app/ListingPage/FETCH_MONTHLY_TIME_SLOTS_REQUEST';
export const FETCH_MONTHLY_TIME_SLOTS_SUCCESS = 'app/ListingPage/FETCH_MONTHLY_TIME_SLOTS_SUCCESS';
export const FETCH_MONTHLY_TIME_SLOTS_ERROR = 'app/ListingPage/FETCH_MONTHLY_TIME_SLOTS_ERROR';

export const FETCH_TIME_SLOTS_FOR_DATE_REQUEST =
  'app/ListingPage/FETCH_TIME_SLOTS_FOR_DATE_REQUEST';
export const FETCH_TIME_SLOTS_FOR_DATE_SUCCESS =
  'app/ListingPage/FETCH_TIME_SLOTS_FOR_DATE_SUCCESS';
export const FETCH_TIME_SLOTS_FOR_DATE_ERROR = 'app/ListingPage/FETCH_TIME_SLOTS_FOR_DATE_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/ListingPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/ListingPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/ListingPage/FETCH_LINE_ITEMS_ERROR';

export const SEND_INQUIRY_REQUEST = 'app/ListingPage/SEND_INQUIRY_REQUEST';
export const SEND_INQUIRY_SUCCESS = 'app/ListingPage/SEND_INQUIRY_SUCCESS';
export const SEND_INQUIRY_ERROR = 'app/ListingPage/SEND_INQUIRY_ERROR';

export const SET_MESSAGE_TXN_ID = 'app/ListingPage/SET_MESSAGE_TXN_ID';
export const SET_APPLY_TXN_ID = 'app/ListingPage/SET_APPLY_TXN_ID';
export const SET_ENABLE_MESSAGE_BUTTON = 'app/ListingPage/SET_ENABLE_MESSAGE_BUTTON';

export const INITIATE_APPLY_TRANSACTION_REQUEST = 'app/ListingPage/INITIATE_APPLY_TRANSACTION_REQUEST';
export const INITIATE_APPLY_TRANSACTION_SUCCESS = 'app/ListingPage/INITIATE_APPLY_TRANSACTION_SUCCESS';
export const INITIATE_APPLY_TRANSACTION_ERROR = 'app/ListingPage/INITIATE_APPLY_TRANSACTION_ERROR';

export const UPDATE_APPLIER_PROFILE_REQUEST = 'app/ListingPage/UPDATE_APPLIER_PROFILE_REQUEST';
export const UPDATE_APPLIER_PROFILE_SUCCESS = 'app/ListingPage/UPDATE_APPLIER_PROFILE_SUCCESS';
export const UPDATE_APPLIER_PROFILE_ERROR = 'app/ListingPage/UPDATE_APPLIER_PROFILE_ERROR';

export const UPDATE_APPLIED_LISTING_REQUEST = 'app/ListingPage/UPDATE_APPLIED_LISTING_REQUEST';
export const UPDATE_APPLIED_LISTING_SUCCESS = 'app/ListingPage/UPDATE_APPLIED_LISTING_SUCCESS';
export const UPDATE_APPLIED_LISTING_ERROR = 'app/ListingPage/UPDATE_APPLIED_LISTING_ERROR';

export const INITIATE_MANUAL_TXN_REQUEST = 'app/ListingPage/INITIATE_MANUAL_TXN_REQUEST';
export const INITIATE_MANUAL_TXN_SUCCESS = 'app/ListingPage/INITIATE_MANUAL_TXN_SUCCESS';
export const INITIATE_MANUAL_TXN_ERROR = 'app/ListingPage/INITIATE_MANUAL_TXN_ERROR';

export const SEND_MANUAL_MESSAGE_REQUEST = 'app/ListingPage/SEND_MANUAL_MESSAGE_REQUEST';
export const SEND_MANUAL_MESSAGE_SUCCESS = 'app/ListingPage/SEND_MANUAL_MESSAGE_SUCCESS';
export const SEND_MANUAL_MESSAGE_ERROR = 'app/ListingPage/SEND_MANUAL_MESSAGE_ERROR';

export const GET_MANUAL_TXNS_BTW_USERS_REQUEST = 'app/ListingPage/GET_MANUAL_TXNS_BTW_USERS_REQUEST';
export const GET_MANUAL_TXNS_BTW_USERS_SUCCESS = 'app/ListingPage/GET_MANUAL_TXNS_BTW_USERS_SUCCESS';
export const GET_MANUAL_TXNS_BTW_USERS_ERROR = 'app/ListingPage/GET_MANUAL_TXNS_BTW_USERS_ERROR';

export const GET_ALL_CANDIDATES_LISTINGS_REQUEST = 'app/ListingPage/GET_ALL_CANDIDATES_LISTINGS_REQUEST';
export const GET_ALL_CANDIDATES_LISTINGS_SUCCESS = 'app/ListingPage/GET_ALL_CANDIDATES_LISTINGS_SUCCESS';
export const GET_ALL_CANDIDATES_LISTINGS_ERROR = 'app/ListingPage/GET_ALL_CANDIDATES_LISTINGS_ERROR';

export const REQUEST_DOCUMENTATION_PRESENTATION_REQUEST = 'app/ListingPage/REQUEST_DOCUMENTATION_PRESENTATION_REQUEST';
export const REQUEST_DOCUMENTATION_PRESENTATION_SUCCESS = 'app/ListingPage/REQUEST_DOCUMENTATION_PRESENTATION_SUCCESS';
export const REQUEST_DOCUMENTATION_PRESENTATION_ERROR = 'app/ListingPage/REQUEST_DOCUMENTATION_PRESENTATION_ERROR';

export const FETCH_REQUEST_RECORDS_REQUEST = 'app/ListingPage/FETCH_REQUEST_RECORDS_REQUEST';
export const FETCH_REQUEST_RECORDS_SUCCESS = 'app/ListingPage/FETCH_REQUEST_RECORDS_SUCCESS';
export const FETCH_REQUEST_RECORDS_ERROR = 'app/ListingPage/FETCH_REQUEST_RECORDS_ERROR';

export const PAY_FOR_RFP_REQUEST = 'app/SearchPage/PAY_FOR_RFP_REQUEST';
export const PAY_FOR_RFP_SUCCESS = 'app/SearchPage/PAY_FOR_RFP_SUCCESS';
export const PAY_FOR_RFP_ERROR = 'app/SearchPage/PAY_FOR_RFP_ERROR';

export const SAVE_RFP_PAYMENT_REQUEST = 'app/ListingPage/SAVE_RFP_PAYMENT_REQUEST';
export const SAVE_RFP_PAYMENT_SUCCESS = 'app/ListingPage/SAVE_RFP_PAYMENT_SUCCESS';
export const SAVE_RFP_PAYMENT_ERROR = 'app/ListingPage/SAVE_RFP_PAYMENT_ERROR';

export const FETCH_USER_EMAIL_REQUEST = 'app/ListingPage/FETCH_USER_EMAIL_REQUEST';
export const FETCH_USER_EMAIL_SUCCESS = 'app/ListingPage/FETCH_USER_EMAIL_SUCCESS';
export const FETCH_USER_EMAIL_ERROR = 'app/ListingPage/FETCH_USER_EMAIL_ERROR';

export const REQUEST_SHARE_OTP_REQUEST = 'app/ListingPage/REQUEST_SHARE_OTP_REQUEST';
export const REQUEST_SHARE_OTP_SUCCESS = 'app/ListingPage/REQUEST_SHARE_OTP_SUCCESS';
export const REQUEST_SHARE_OTP_ERROR = 'app/ListingPage/REQUEST_SHARE_OTP_ERROR';

export const VERIFY_SHARE_OTP_REQUEST = 'app/ListingPage/VERIFY_SHARE_OTP_REQUEST';
export const VERIFY_SHARE_OTP_SUCCESS = 'app/ListingPage/VERIFY_SHARE_OTP_SUCCESS';
export const VERIFY_SHARE_OTP_ERROR = 'app/ListingPage/VERIFY_SHARE_OTP_ERROR';

export const GET_SHARED_PROFILE_REQUEST = 'app/ListingPage/GET_SHARED_PROFILE_REQUEST';
export const GET_SHARED_PROFILE_SUCCESS = 'app/ListingPage/GET_SHARED_PROFILE_SUCCESS';
export const GET_SHARED_PROFILE_ERROR = 'app/ListingPage/GET_SHARED_PROFILE_ERROR';

export const REQUEST_PROFILE_ACCESS_REQUEST = 'app/ListingPage/REQUEST_PROFILE_ACCESS_REQUEST';
export const REQUEST_PROFILE_ACCESS_SUCCESS = 'app/ListingPage/REQUEST_PROFILE_ACCESS_SUCCESS';
export const REQUEST_PROFILE_ACCESS_ERROR = 'app/ListingPage/REQUEST_PROFILE_ACCESS_ERROR';

export const SET_LOADING_STATE = 'app/ListingPage/SET_LOADING_STATE';
export const SET_MAINUSERID = 'app/ListingPage/SET_MAINUSERID';
export const SET_PROFILELISTING = 'app/ListingPage/SET_PROFILELISTING';
export const SET_JOBRFPLISTINGS_OF_CUSTOMER = 'app/ListingPage/SET_JOBRFPLISTINGS_OF_CUSTOMER';
export const SET_CURRENTLISTING_ADMIN = 'app/ListingPage/SET_CURRENTLISTING_ADMIN';
export const SET_POSTING_FORWARD = 'app/ListingPage/SET_POSTING_FORWARD';

export const FETCH_RFP_FREE_APPLICATIONS_REQUEST = 'app/ListingPage/FETCH_RFP_FREE_APPLICATIONS_REQUEST';
export const FETCH_RFP_FREE_APPLICATIONS_SUCCESS = 'app/ListingPage/FETCH_RFP_FREE_APPLICATIONS_SUCCESS';
export const FETCH_RFP_FREE_APPLICATIONS_ERROR = 'app/ListingPage/FETCH_RFP_FREE_APPLICATIONS_ERROR';

export const CHECK_INTEGRITY_STATUS_REQUEST = 'app/ListingPage/CHECK_INTEGRITY_STATUS_REQUEST';
export const CHECK_INTEGRITY_STATUS_SUCCESS = 'app/ListingPage/CHECK_INTEGRITY_STATUS_SUCCESS';
export const CHECK_INTEGRITY_STATUS_ERROR = 'app/ListingPage/CHECK_INTEGRITY_STATUS_ERROR';

export const FETCH_JOB_CONSENT_REQUEST = 'app/ListingPage/FETCH_JOB_CONSENT_REQUEST';
export const FETCH_JOB_CONSENT_SUCCESS = 'app/ListingPage/FETCH_JOB_CONSENT_SUCCESS';
export const FETCH_JOB_CONSENT_ERROR = 'app/ListingPage/FETCH_JOB_CONSENT_ERROR';

export const UPDATE_TRANSACTION_DOCUMENTS_REQUEST = 'app/ListingPage/UPDATE_TRANSACTION_DOCUMENTS_REQUEST';
export const UPDATE_TRANSACTION_DOCUMENTS_SUCCESS = 'app/ListingPage/UPDATE_TRANSACTION_DOCUMENTS_SUCCESS';
export const UPDATE_TRANSACTION_DOCUMENTS_ERROR = 'app/ListingPage/UPDATE_TRANSACTION_DOCUMENTS_ERROR';

// ================ Reducer ================ //

// Candidate listings fetched for one page of consultants are added to those fetched for others,
// replacing any fetched again.
const withListings = (kept = [], fetched = []) => {
  const fetchedIds = new Set((fetched || []).map(l => l.id?.uuid));
  return [...(kept || []).filter(l => !fetchedIds.has(l.id?.uuid)), ...(fetched || [])];
};

const initialState = {
  id: null,
  // Set when the server's read of a job or RFP says the viewer reads it only through primes'
  // forwards: `{ sharedBy, customerShown }`.
  postingForward: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  timeSlotsForDate: {
    // For small time units, we fetch monthly time slots with sparse mode for calendar view
    // and when the user clicks on a day, we make a full time slot query. This is for that purpose.
    // '2025-02-03': {
    //   timeSlots: [],
    //   fetchedAt: 1738569600000,
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  sendInquiryInProgress: false,
  sendInquiryError: null,
  inquiryModalOpenForListingId: null,
  messageTxnId: null,
  applyTxnId: null,
  initiateApplyTransactionError: null,
  updateApplierProfileError: null,
  updateAppliedListingError: null,
  applied: false,
  applying: false,
  updatedApplierProfile: false,
  mainUserId: null,
  profileListing: null,
  manualTxnId: null,
  manualTxnError: null,
  manualMessageSent: false,
  manualMessageError: null,
  getManualTxnSuc: false,
  getManualTxnError: null,
  getAllCandidatesListingsInProgress: false,
  getAllCandidatesListingsError: null,
  candidatesListings: [],
  enableMessageButton: false,
  jobRfpListingsOfCus: null,
  currentListingAdmin: null,
  fetchRequestRecordsInProgress: false,
  fetchRequestRecordsError: null,
  requestRecords: [],
  loading: false,
  payForRFPError: null,
  rfpFreeApplicationsCount: 0,
  fetchRfpFreeApplicationsInProgress: false,
  fetchRfpFreeApplicationsError: null,
  authorEmail: null,
  fetchAuthorEmailInProgress: false,
  fetchAuthorEmailError: null,
  requestShareOtpInProgress: false,
  requestShareOtpError: null,
  shareOtpEmail: null,
  verifyShareOtpInProgress: false,
  verifyShareOtpError: null,
  shareOtpVerified: false,
  getSharedProfileInProgress: false,
  getSharedProfileError: null,
  sharedProfileData: null,
  isSharedView: false,
  savingRFPPaymentError: null,
  savingRFPPaymentSuccess: false,
  savingRFPPayment: false,
  requestProfileAccessInProgress: false,
  requestProfileAccessError: null,
  requestProfileAccessSuccess: false,
  integrityCheckStatus: null,
  checkIntegrityStatusInProgress: false,
  fetchJobConsentInProgress: false,
  fetchJobConsentError: null,
  hasConsentForJob: false,
  updateTransactionDocumentsInProgress: false,
  updateTransactionDocumentsError: null,
};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null, postingForward: null };
    case SET_POSTING_FORWARD:
      return { ...state, postingForward: payload };
    case SHOW_LISTINGS_SUCCESS:
      return { ...state, showListingError: null };
    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case FETCH_REVIEWS_REQUEST:
      return { ...state, fetchReviewsError: null };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsError: payload };

    case FETCH_MONTHLY_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_MONTHLY_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_MONTHLY_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_FOR_DATE_REQUEST: {
      const timeSlotsForDate = {
        ...removeOutdatedDateData(state.timeSlotsForDate),
        [payload]: {
          ...state.timeSlotsForDate[payload],
          fetchTimeSlotsError: null,
          fetchedAt: null,
          fetchTimeSlotsInProgress: true,
          timeSlots: [],
        },
      };
      return { ...state, timeSlotsForDate };
    }
    case FETCH_TIME_SLOTS_FOR_DATE_SUCCESS: {
      const dateId = payload.dateId;
      const timeSlotsForDate = {
        ...state.timeSlotsForDate,
        [dateId]: {
          ...state.timeSlotsForDate[dateId],
          fetchTimeSlotsInProgress: false,
          fetchedAt: new Date().getTime(),
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, timeSlotsForDate };
    }
    case FETCH_TIME_SLOTS_FOR_DATE_ERROR: {
      const dateId = payload.dateId;
      const timeSlotsForDate = {
        ...state.timeSlotsForDate,
        [dateId]: {
          ...state.timeSlotsForDate[dateId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, timeSlotsForDate };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case SEND_INQUIRY_REQUEST:
      return { ...state, sendInquiryInProgress: true, sendInquiryError: null };
    case SEND_INQUIRY_SUCCESS:
      return { ...state, sendInquiryInProgress: false, inquiryModalOpenForListingId: null };
    case SEND_INQUIRY_ERROR:
      return { ...state, sendInquiryInProgress: false, sendInquiryError: payload };

    case SET_MESSAGE_TXN_ID:
      return { ...state, messageTxnId: action.payload };

    case SET_APPLY_TXN_ID:
      return { ...state, applyTxnId: action.payload };

    case SET_ENABLE_MESSAGE_BUTTON:
      return { ...state, enableMessageButton: action.payload };

    case INITIATE_APPLY_TRANSACTION_REQUEST:
      return { ...state, initiateApplyTransactionError: null, applying: true };
    case INITIATE_APPLY_TRANSACTION_SUCCESS:
      return { ...state, initiateApplyTransactionError: null, applied: true, applying: false };
    case INITIATE_APPLY_TRANSACTION_ERROR:
      return { ...state, initiateApplyTransactionError: payload, applying: false };

    case UPDATE_APPLIER_PROFILE_REQUEST:
      return { ...state, updateApplierProfileError: null };
    case UPDATE_APPLIER_PROFILE_SUCCESS:
      return { ...state, updateApplierProfileError: null, updatedApplierProfile: true };
    case UPDATE_APPLIER_PROFILE_ERROR:
      return { ...state, updateApplierProfileError: payload };

    case UPDATE_APPLIED_LISTING_REQUEST:
      return { ...state, updateAppliedListingError: null };
    case UPDATE_APPLIED_LISTING_SUCCESS:
      return { ...state, updateAppliedListingError: null };
    case UPDATE_APPLIED_LISTING_ERROR:
      return { ...state, updateAppliedListingError: payload };

    case INITIATE_MANUAL_TXN_REQUEST:
      return { ...state, manualTxnId: null, manualTxnError: null };
    case INITIATE_MANUAL_TXN_SUCCESS:
      return { ...state, manualTxnId: payload };
    case INITIATE_MANUAL_TXN_ERROR:
      return { ...state, manualTxnError: payload };

    case SEND_MANUAL_MESSAGE_REQUEST:
      return { ...state, manualMessageSent: false, manualMessageError: null };
    case SEND_MANUAL_MESSAGE_SUCCESS:
      return { ...state, manualMessageSent: true, manualMessageError: null };
    case SEND_MANUAL_MESSAGE_ERROR:
      return { ...state, manualMessageSent: false, manualMessageError: payload };

    case GET_MANUAL_TXNS_BTW_USERS_REQUEST:
      return { ...state, getManualTxnSuc: false, getManualTxnError: null };
    case GET_MANUAL_TXNS_BTW_USERS_SUCCESS:
      return { ...state, getManualTxnSuc: true, manualTxnId: payload, getManualTxnError: null };
    case GET_MANUAL_TXNS_BTW_USERS_ERROR:
      return { ...state, getManualTxnSuc: false, getManualTxnError: payload };

    case SET_MAINUSERID:
      return { ...state, mainUserId: payload };

    case SET_PROFILELISTING:
      return { ...state, profileListing: payload };

    case GET_ALL_CANDIDATES_LISTINGS_REQUEST:
      return {
        ...state,
        getAllCandidatesListingsInProgress: true,
        getAllCandidatesListingsError: null,
      };
    case GET_ALL_CANDIDATES_LISTINGS_SUCCESS:
      return {
        ...state,
        getAllCandidatesListingsInProgress: false,
        candidatesListings: withListings(state.candidatesListings, payload),
      };
    case GET_ALL_CANDIDATES_LISTINGS_ERROR:
      return {
        ...state,
        getAllCandidatesListingsInProgress: false,
        getAllCandidatesListingsError: payload,
      };

    case REQUEST_DOCUMENTATION_PRESENTATION_REQUEST:
      return {
        ...state,
      };
    case REQUEST_DOCUMENTATION_PRESENTATION_SUCCESS:
      return {
        ...state,
      };
    case REQUEST_DOCUMENTATION_PRESENTATION_ERROR:
      return {
        ...state,
      };

    case FETCH_REQUEST_RECORDS_REQUEST:
      return {
        ...state,
        fetchRequestRecordsInProgress: true,
        fetchRequestRecordsError: null,
      };
    case FETCH_REQUEST_RECORDS_SUCCESS:
      return {
        ...state,
        fetchRequestRecordsInProgress: false,
        requestRecords: payload,
      };
    case FETCH_REQUEST_RECORDS_ERROR:
      return {
        ...state,
        fetchRequestRecordsInProgress: false,
        fetchRequestRecordsError: payload,
      };

    case FETCH_USER_EMAIL_REQUEST:
      return {
        ...state,
        fetchAuthorEmailInProgress: true,
        fetchAuthorEmailError: null,
      };
    case FETCH_USER_EMAIL_SUCCESS:
      return {
        ...state,
        fetchAuthorEmailInProgress: false,
        authorEmail: payload,
      };
    case FETCH_USER_EMAIL_ERROR:
      return {
        ...state,
        fetchAuthorEmailInProgress: false,
        fetchAuthorEmailError: payload,
      };

    case REQUEST_SHARE_OTP_REQUEST:
      return {
        ...state,
        requestShareOtpInProgress: true,
        requestShareOtpError: null,
      };
    case REQUEST_SHARE_OTP_SUCCESS:
      return {
        ...state,
        requestShareOtpInProgress: false,
        shareOtpEmail: payload.email,
      };
    case REQUEST_SHARE_OTP_ERROR:
      return {
        ...state,
        requestShareOtpInProgress: false,
        requestShareOtpError: payload,
      };

    case VERIFY_SHARE_OTP_REQUEST:
      return {
        ...state,
        verifyShareOtpInProgress: true,
        verifyShareOtpError: null,
      };
    case VERIFY_SHARE_OTP_SUCCESS:
      return {
        ...state,
        verifyShareOtpInProgress: false,
        shareOtpVerified: true,
      };
    case VERIFY_SHARE_OTP_ERROR:
      return {
        ...state,
        verifyShareOtpInProgress: false,
        verifyShareOtpError: payload,
      };

    case GET_SHARED_PROFILE_REQUEST:
      return {
        ...state,
        getSharedProfileInProgress: true,
        getSharedProfileError: null,
      };
    case GET_SHARED_PROFILE_SUCCESS:
      return {
        ...state,
        getSharedProfileInProgress: false,
        sharedProfileData: payload,
        isSharedView: payload.isSharedView || false,
      };
    case GET_SHARED_PROFILE_ERROR:
      return {
        ...state,
        getSharedProfileInProgress: false,
        getSharedProfileError: payload,
      };

    case PAY_FOR_RFP_REQUEST:
      return {
        ...state,
        payForRFPError: null,
      };

    case PAY_FOR_RFP_SUCCESS:
      const { url } = payload;
      window.location.href = url;

      return {
        ...state,
        payForRFPError: null,
      };

    case PAY_FOR_RFP_ERROR:
      return {
        ...state,
        payForRFPError: payload,
      };

    case SAVE_RFP_PAYMENT_REQUEST:
      return {
        ...state,
        savingRFPPayment: true,
        savingRFPPaymentSuccess: false,
        savingRFPPaymentError: null,
      };
    case SAVE_RFP_PAYMENT_SUCCESS:
      return {
        ...state,
        savingRFPPayment: false,
        savingRFPPaymentSuccess: true,
        savingRFPPaymentError: null,
      };
    case SAVE_RFP_PAYMENT_ERROR:
      return {
        ...state,
        savingRFPPayment: false,
        savingRFPPaymentSuccess: false,
        savingRFPPaymentError: payload,
      };

    case REQUEST_PROFILE_ACCESS_REQUEST:
      return {
        ...state,
        requestProfileAccessInProgress: true,
        requestProfileAccessError: null,
        requestProfileAccessSuccess: false,
      };
    case REQUEST_PROFILE_ACCESS_SUCCESS:
      return {
        ...state,
        requestProfileAccessInProgress: false,
        requestProfileAccessSuccess: true,
      };
    case REQUEST_PROFILE_ACCESS_ERROR:
      return {
        ...state,
        requestProfileAccessInProgress: false,
        requestProfileAccessError: payload,
        requestProfileAccessSuccess: false,
      };

    case SET_JOBRFPLISTINGS_OF_CUSTOMER:
      return { ...state, jobRfpListingsOfCus: payload };

    case SET_CURRENTLISTING_ADMIN:
      return { ...state, currentListingAdmin: payload };

    case SET_LOADING_STATE:
      return { ...state, loading: payload };

    case FETCH_RFP_FREE_APPLICATIONS_REQUEST:
      return {
        ...state,
        fetchRfpFreeApplicationsInProgress: true,
        fetchRfpFreeApplicationsError: null,
      };

    case FETCH_RFP_FREE_APPLICATIONS_SUCCESS:
      return {
        ...state,
        fetchRfpFreeApplicationsInProgress: false,
        rfpFreeApplicationsCount: payload.count,
        fetchRfpFreeApplicationsError: null,
      };

    case FETCH_RFP_FREE_APPLICATIONS_ERROR:
      return {
        ...state,
        fetchRfpFreeApplicationsInProgress: false,
        fetchRfpFreeApplicationsError: payload,
      };

    case CHECK_INTEGRITY_STATUS_REQUEST:
      return { ...state, checkIntegrityStatusInProgress: true, integrityCheckStatus: null };
    case CHECK_INTEGRITY_STATUS_SUCCESS:
      return { ...state, checkIntegrityStatusInProgress: false, integrityCheckStatus: payload };
    case CHECK_INTEGRITY_STATUS_ERROR:
      return { ...state, checkIntegrityStatusInProgress: false };

    case FETCH_JOB_CONSENT_REQUEST:
      return { ...state, fetchJobConsentInProgress: true, fetchJobConsentError: null };
    case FETCH_JOB_CONSENT_SUCCESS:
      return { ...state, fetchJobConsentInProgress: false, hasConsentForJob: payload };
    case FETCH_JOB_CONSENT_ERROR:
      return { ...state, fetchJobConsentInProgress: false, fetchJobConsentError: payload };

    case UPDATE_TRANSACTION_DOCUMENTS_REQUEST:
      return { ...state, updateTransactionDocumentsInProgress: true, updateTransactionDocumentsError: null };
    case UPDATE_TRANSACTION_DOCUMENTS_SUCCESS:
      return { ...state, updateTransactionDocumentsInProgress: false };
    case UPDATE_TRANSACTION_DOCUMENTS_ERROR:
      return { ...state, updateTransactionDocumentsInProgress: false, updateTransactionDocumentsError: payload };

    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});

export const showListingSuccess = payload => ({
  type: SHOW_LISTINGS_SUCCESS,
  payload: payload,
});

export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

export const fetchMonthlyTimeSlotsRequest = monthId => ({
  type: FETCH_MONTHLY_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchMonthlyTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_MONTHLY_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchMonthlyTimeSlotsError = (monthId, error) => ({
  type: FETCH_MONTHLY_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchTimeSlotsForDateRequest = dateId => ({
  type: FETCH_TIME_SLOTS_FOR_DATE_REQUEST,
  payload: dateId,
});
export const fetchTimeSlotsForDateSuccess = (dateId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_FOR_DATE_SUCCESS,
  payload: { timeSlots, dateId },
});
export const fetchTimeSlotsForDateError = (dateId, error) => ({
  type: FETCH_TIME_SLOTS_FOR_DATE_ERROR,
  error: true,
  payload: { dateId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const sendInquiryRequest = () => ({ type: SEND_INQUIRY_REQUEST });
export const sendInquirySuccess = () => ({ type: SEND_INQUIRY_SUCCESS });
export const sendInquiryError = e => ({ type: SEND_INQUIRY_ERROR, error: true, payload: e });

export const setMessageTxnId = messageTxnId => ({
  type: SET_MESSAGE_TXN_ID,
  payload: messageTxnId,
});

export const setApplyTxnId = applyTxnId => ({
  type: SET_APPLY_TXN_ID,
  payload: applyTxnId,
});

export const setEnableMessageButton = enableMessageButton => ({
  type: SET_ENABLE_MESSAGE_BUTTON,
  payload: enableMessageButton,
});

export const initiateApplyTransactionRequest = () => ({ type: INITIATE_APPLY_TRANSACTION_REQUEST });
export const initiateApplyTransactionSuccess = () => ({ type: INITIATE_APPLY_TRANSACTION_SUCCESS });
export const initiateApplyTransactionError = e => ({
  type: INITIATE_APPLY_TRANSACTION_ERROR,
  error: true,
  payload: e,
});

export const updateApplierProfileRequest = () => ({ type: UPDATE_APPLIER_PROFILE_REQUEST });
export const updateApplierProfileSuccess = () => ({ type: UPDATE_APPLIER_PROFILE_SUCCESS });
export const updateApplierProfileError = e => ({
  type: UPDATE_APPLIER_PROFILE_ERROR,
  error: true,
  payload: e,
});

export const updateAppliedListingRequest = () => ({ type: UPDATE_APPLIED_LISTING_REQUEST });
export const updateAppliedListingSuccess = () => ({ type: UPDATE_APPLIED_LISTING_SUCCESS });
export const updateAppliedListingError = e => ({
  type: UPDATE_APPLIED_LISTING_ERROR,
  error: true,
  payload: e,
});

export const initiateManualTxnRequest = () => ({ type: INITIATE_MANUAL_TXN_REQUEST });
export const initiateManualTxnSuccess = payload => ({ type: INITIATE_MANUAL_TXN_SUCCESS, payload });
export const initiateManualTxnError = e => ({
  type: INITIATE_MANUAL_TXN_ERROR,
  error: true,
  payload: e,
});

export const sendManualMessageRequest = () => ({ type: SEND_MANUAL_MESSAGE_REQUEST });
export const sendManualMessageSuccess = () => ({ type: SEND_MANUAL_MESSAGE_SUCCESS });
export const sendManualMessageError = e => ({
  type: SEND_MANUAL_MESSAGE_ERROR,
  error: true,
  payload: e,
});

export const getManualTxnBtwUsersRequest = () => ({ type: GET_MANUAL_TXNS_BTW_USERS_REQUEST });
export const getManualTxnBtwUsersSuccess = payload => ({ type: GET_MANUAL_TXNS_BTW_USERS_SUCCESS, payload });
export const getManualTxnBtwUsersError = e => ({
  type: GET_MANUAL_TXNS_BTW_USERS_ERROR,
  error: true,
  payload: e,
});

export const setMainUserId = mainUserId => ({
  type: SET_MAINUSERID,
  payload: mainUserId,
});

// export const setProfileListing = profileListing => ({
//   type: SET_PROFILELISTING,
//   payload: profileListing,
// });

export const getAllCandidatesListingsRequest = params => ({
  type: GET_ALL_CANDIDATES_LISTINGS_REQUEST,
  payload: { params },
});
export const getAllCandidatesListingsSuccess = result => ({
  type: GET_ALL_CANDIDATES_LISTINGS_SUCCESS,
  payload: result,
});
export const getAllCandidatesListingsError = error => ({
  type: GET_ALL_CANDIDATES_LISTINGS_ERROR,
  payload: error,
  error: true,
});

export const requestDocumentPresentationRequest = params => ({
  type: REQUEST_DOCUMENTATION_PRESENTATION_REQUEST,
  payload: { params },
});
export const requestDocumentPresentationSuccess = result => ({
  type: REQUEST_DOCUMENTATION_PRESENTATION_SUCCESS,
  payload: result,
});
export const requestDocumentPresentationError = error => ({
  type: REQUEST_DOCUMENTATION_PRESENTATION_ERROR,
  payload: error,
  error: true,
});

export const fetchRequestRecordsRequest = params => ({
  type: FETCH_REQUEST_RECORDS_REQUEST,
  payload: { params },
});
export const fetchRequestRecordsSuccess = result => ({
  type: FETCH_REQUEST_RECORDS_SUCCESS,
  payload: result,
});
export const fetchRequestRecordsError = error => ({
  type: FETCH_REQUEST_RECORDS_ERROR,
  payload: error,
  error: true,
});

export const payForRFPRequest = () => ({
  type: PAY_FOR_RFP_REQUEST,
});

export const payForRFPSuccess = (response) => ({
  type: PAY_FOR_RFP_SUCCESS,
  payload: response,
});

export const payForRFPError = e => ({
  type: PAY_FOR_RFP_ERROR,
  error: true,
  payload: e,
});

export const saveRFPPaymentRequest = () => ({
  type: SAVE_RFP_PAYMENT_REQUEST,
});

export const saveRFPPaymentSuccess = (response) => ({
  type: SAVE_RFP_PAYMENT_SUCCESS,
  payload: response,
});

export const saveRFPPaymentError = e => ({
  type: SAVE_RFP_PAYMENT_ERROR,
  error: true,
  payload: e,
});

export const fetchUserEmailRequest = () => ({
  type: FETCH_USER_EMAIL_REQUEST,
});
export const fetchUserEmailSuccess = result => ({
  type: FETCH_USER_EMAIL_SUCCESS,
  payload: result,
});
export const fetchUserEmailError = error => ({
  type: FETCH_USER_EMAIL_ERROR,
  payload: error,
  error: true,
});

// Request Share OTP action creators
export const requestShareOtpRequest = () => ({
  type: REQUEST_SHARE_OTP_REQUEST,
});
export const requestShareOtpSuccess = result => ({
  type: REQUEST_SHARE_OTP_SUCCESS,
  payload: result,
});
export const requestShareOtpError = error => ({
  type: REQUEST_SHARE_OTP_ERROR,
  payload: error,
  error: true,
});

// Verify Share OTP action creators
export const verifyShareOtpRequest = () => ({
  type: VERIFY_SHARE_OTP_REQUEST,
});
export const verifyShareOtpSuccess = result => ({
  type: VERIFY_SHARE_OTP_SUCCESS,
  payload: result,
});
export const verifyShareOtpError = error => ({
  type: VERIFY_SHARE_OTP_ERROR,
  payload: error,
  error: true,
});

// Get Shared Profile action creators
export const getSharedProfileRequest = () => ({
  type: GET_SHARED_PROFILE_REQUEST,
});
export const getSharedProfileSuccess = result => ({
  type: GET_SHARED_PROFILE_SUCCESS,
  payload: result,
});
export const getSharedProfileError = error => ({
  type: GET_SHARED_PROFILE_ERROR,
  payload: error,
  error: true,
});

// Request Profile Access action creators
export const requestProfileAccessRequest = () => ({
  type: REQUEST_PROFILE_ACCESS_REQUEST,
});
export const requestProfileAccessSuccess = result => ({
  type: REQUEST_PROFILE_ACCESS_SUCCESS,
  payload: result,
});
export const requestProfileAccessError = error => ({
  type: REQUEST_PROFILE_ACCESS_ERROR,
  payload: error,
  error: true,
});

export const fetchJobConsentRequest = () => ({
  type: FETCH_JOB_CONSENT_REQUEST,
});
export const fetchJobConsentSuccess = hasConsent => ({
  type: FETCH_JOB_CONSENT_SUCCESS,
  payload: hasConsent,
});
export const fetchJobConsentError = error => ({
  type: FETCH_JOB_CONSENT_ERROR,
  payload: error,
  error: true,
});

export const updateTransactionDocumentsRequest = () => ({
  type: UPDATE_TRANSACTION_DOCUMENTS_REQUEST,
});
export const updateTransactionDocumentsSuccess = result => ({
  type: UPDATE_TRANSACTION_DOCUMENTS_SUCCESS,
  payload: result,
});
export const updateTransactionDocumentsError = error => ({
  type: UPDATE_TRANSACTION_DOCUMENTS_ERROR,
  payload: error,
  error: true,
});

export const setJobRfpListingsOfCus = jobRfpListingsOfCus => ({
  type: SET_JOBRFPLISTINGS_OF_CUSTOMER,
  payload: jobRfpListingsOfCus,
});

export const setLoadingState = loading => ({
  type: SET_LOADING_STATE,
  payload: loading,
});

export const setPostingForward = forward => ({ type: SET_POSTING_FORWARD, payload: forward || null });

export const setCurrentListingAdmin = currentListingAdmin => ({
  type: SET_CURRENTLISTING_ADMIN,
  payload: currentListingAdmin,
});

export const fetchRfpFreeApplicationsRequest = () => ({
  type: FETCH_RFP_FREE_APPLICATIONS_REQUEST,
});

export const fetchRfpFreeApplicationsSuccess = count => ({
  type: FETCH_RFP_FREE_APPLICATIONS_SUCCESS,
  payload: { count },
});

export const fetchRfpFreeApplicationsError = error => ({
  type: FETCH_RFP_FREE_APPLICATIONS_ERROR,
  error: true,
  payload: error,
});

// ================ Thunks ================ //
const RESULT_PAGE_SIZE = 42;

const getIdString = (id) => (typeof id === 'object' && id !== null ? id?.uuid : id);

export const showListing = (listingId, config, isOwn = false) => async (dispatch, getState, sdk) => {
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  dispatch(showListingRequest(listingId));

  const { currentUser } = getState().user;
  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId || currentUser?.attributes?.profile?.publicData?.firstListingId;
  let mainUserId = '';

  if (profileListingId) {
    try {
      let profileListing = await sdk.listings.show({ id: profileListingId });
      profileListing = profileListing?.data?.data;
      mainUserId = profileListing?.attributes?.publicData?.adminId;
    } catch (error) {
      // Error fetching profile listing - non-critical, continue
    }
  }

  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'images', 'currentStock'],
    'fields.image': [
      // Scaled variants for large images
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Cropped variants for listing thumbnail images
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
  };

  const show = isOwn ? sdk.ownListings.show(params) : showPostingListing(sdk, params);

  return show
    .then(async data => {
      const listingType = data?.data?.data?.attributes?.publicData?.listingType;
      const currentListingAdminId = data?.data?.data?.attributes?.publicData?.adminId || data?.data?.data?.relationships?.author?.data?.id?.uuid;

      try {
        let currentListingAdmin = await getUserDetails({
          userId: currentListingAdminId,
          listingId,
          listingPage: true,
          responseFields: [
            'profile.displayName',
            'profile.publicData.agencyProfile',
            'profile.publicData.customerProfile',
            'profile.publicData.profileListingId',
            'profile.publicData.firstListingId',
          ],
          imageFields: ['variants.default'],
        });
        currentListingAdmin = {
          ...currentListingAdmin?.data?.data,
          profileImage: currentListingAdmin?.data?.included?.[0],
        };
        dispatch(setCurrentListingAdmin(currentListingAdmin));
      } catch (error) {
        // Error fetching current listing admin - non-critical, continue
      }

      if (listingType === 'rfp_listing' || listingType === 'job_listing') {
        const listingFields = config?.listing?.listingFields;
        const sanitizeConfig = { listingFields };
        // Populate basic SDK data immediately so SSR has listing state for meta tags.
        // getListingWithPrivateData calls window.fetch which throws during SSR (window is undefined).
        dispatch(addMarketplaceEntities(data, sanitizeConfig));
        dispatch(showListingSuccess(data));
        // Use try/catch + await so synchronous throws (e.g. window is not defined in SSR)
        // are caught, not just async Promise rejections that .catch() would handle.
        try {
          const privateData = await getListingWithPrivateData({ listingId: listingId, listingPage: true });
          dispatch(addMarketplaceEntities(privateData, sanitizeConfig));
          dispatch(showListingSuccess(privateData));
          dispatch(setPostingForward(privateData?.forward));
          return privateData;
        } catch (e) {
          // Private data fetch failed (expected during SSR); return basic data so loadData
          // callers get a defined listingResponse instead of undefined.
          return data;
        }
      }

      const currentUserType = userTypeOf(currentUser);
      const canPostJobRfp = currentUserType === 'customer';

      if ((listingType === 'candidate' || listingType === 'agency' || listingType === 'customer') && currentUser && canPostJobRfp) {
        try {
          let apiQueryParams = {
            page: 1,
            perPage: RESULT_PAGE_SIZE,
            include: ['images', 'currentStock'],
            authorId: mainUserId,
            pub_listingType: listingType === 'candidate'
              ? 'job_listing'
              : ['job_listing', 'rfp_listing'],
            pub_isDraftListing: false,
            'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
            ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
            ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
            'limit.images': 1,
          };

          let allListingsOfCustomer = await getOwnJobRfpListings({ apiQueryParams, responseFields: ['title', 'state', 'publicData'], publicDataFields: ['isDraftListing', 'listingType', 'invitedUsersToPosting', 'appliers'] });
          allListingsOfCustomer = allListingsOfCustomer?.allListings[0]?.data || [];
          allListingsOfCustomer = allListingsOfCustomer.filter(listing => {
            const isDraft = listing?.attributes?.publicData?.isDraftListing;
            return !isDraft;
          });

          dispatch(setJobRfpListingsOfCus(allListingsOfCustomer));
        } catch (error) {
          // Error fetching customer listings - non-critical, continue
        }
      }

      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      dispatch(addMarketplaceEntities(data, sanitizeConfig));
      dispatch(showListingSuccess(data));
      return data;
    })
    .catch(e => {
      dispatch(showListingError(storableError(e)));
    });
};

export const fetchReviews = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchReviewsRequest());
  return sdk.reviews
    .query({
      listing_id: listingId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(fetchReviewsSuccess(reviews));
    })
    .catch(e => {
      dispatch(fetchReviewsError(storableError(e)));
    });
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone, options) => (
  dispatch,
  getState,
  sdk
) => {
  const { extraQueryParams = null, useFetchTimeSlotsForDate = false } = options || {};

  // The maximum pagination page size for timeSlots is 500
  const extraParams = extraQueryParams || {
    perPage: 500,
    page: 1,
  };

  // For small time units, we fetch the data per date.
  // This is to avoid fetching too much data (with 15 minute intervals, there can be 24*4*31 = 2928 time slots)
  if (useFetchTimeSlotsForDate) {
    const dateId = stringifyDateToISO8601(start, timeZone);
    const dateData = getState().ListingPage.timeSlotsForDate[dateId];
    const minuteAgo = new Date().getTime() - MINUTE_IN_MS;
    const hasRecentlyFetchedData = dateData?.fetchedAt > minuteAgo;
    if (hasRecentlyFetchedData) {
      return Promise.resolve(dateData?.timeSlots || []);
    }

    dispatch(fetchTimeSlotsForDateRequest(dateId));
    return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
      .then(timeSlots => {
        dispatch(fetchTimeSlotsForDateSuccess(dateId, timeSlots));
        return timeSlots;
      })
      .catch(e => {
        dispatch(fetchTimeSlotsForDateError(dateId, storableError(e)));
        return [];
      });
  } else {
    const monthId = monthIdString(start, timeZone);
    dispatch(fetchMonthlyTimeSlotsRequest(monthId));
    return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
      .then(timeSlots => {
        dispatch(fetchMonthlyTimeSlotsSuccess(monthId, timeSlots));
        return timeSlots;
      })
      .catch(e => {
        dispatch(fetchMonthlyTimeSlotsError(monthId, storableError(e)));
        return [];
      });
  }
};

export const sendInquiry = (listing, message) => (dispatch, getState, sdk) => {
  dispatch(sendInquiryRequest());
  const processAlias = listing?.attributes?.publicData?.transactionProcessAlias;
  if (!processAlias) {
    const error = new Error('No transaction process attached to listing');
    log.error(error, 'listing-process-missing', {
      listingId: listing?.id?.uuid,
    });
    dispatch(sendInquiryError(storableError(error)));
    return Promise.reject(error);
  }

  const listingId = listing?.id;
  const [processName, alias] = processAlias.split('/');
  const transitions = getProcess(processName)?.transitions;

  const currentUser = getState().user.currentUser;

  const bodyParams = {
    transition: transitions.INQUIRE,
    processAlias,
    params: { listingId },
  };
  return sdk.transactions
    .initiate(bodyParams)
    .then(async response => {
      const transactionId = response.data.data.id;

      await updateTransactionMetadata({ transactionId: transactionId?.uuid, metadata: { seenByReceivedUser: false, sentUserId: currentUser?.id?.uuid } });

      // Send the message to the created transaction
      return sdk.messages.send({ transactionId, content: message }).then(() => {
        dispatch(sendInquirySuccess());
        dispatch(fetchCurrentUserHasOrdersSuccess(true));
        return transactionId;
      });
    })
    .catch(e => {
      dispatch(sendInquiryError(storableError(e)));
      throw e;
    });
};

// Helper function for loadData call.
// Note: listing could be ownListing entity too
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const { availabilityPlan, publicData } = listing?.attributes || {};
  const tz = availabilityPlan?.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && !!tz) {
    const { unitType, priceVariants, startTimeInterval } = publicData || {};
    const now = new Date();
    const startOfToday = getStartOf(now, 'day', tz);
    const isFixed = unitType === 'fixed';

    const timeUnit = startTimeInterval
      ? bookingTimeUnits[startTimeInterval]?.timeUnit
      : unitType === 'hour'
        ? 'hour'
        : 'day';
    const nextBoundary = findNextBoundary(now, 1, timeUnit, tz);

    const nextMonth = getStartOf(nextBoundary, 'month', tz, 1, 'months');
    const nextAfterNextMonth = getStartOf(nextMonth, 'month', tz, 1, 'months');

    const variants = priceVariants || [];
    const bookingLengthInMinutes = variants.reduce((min, priceVariant) => {
      return Math.min(min, priceVariant.bookingLengthInMinutes);
    }, Number.MAX_SAFE_INTEGER);

    const nextMonthEnd = isFixed
      ? getStartOf(nextMonth, 'minute', tz, bookingLengthInMinutes, 'minutes')
      : nextMonth;
    const followingMonthEnd = isFixed
      ? getStartOf(nextAfterNextMonth, 'minute', tz, bookingLengthInMinutes, 'minutes')
      : nextAfterNextMonth;

    const minDurationStartingInInterval = isFixed ? bookingLengthInMinutes : 60;

    const options = intervalAlign => {
      return ['fixed', 'hour'].includes(unitType)
        ? {
          extraQueryParams: {
            intervalDuration: 'P1D',
            intervalAlign,
            maxPerInterval: 1,
            minDurationStartingInInterval,
            perPage: 31,
            page: 1,
          },
        }
        : null;
    };

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonthEnd, tz, options(startOfToday))),
      dispatch(fetchTimeSlots(listing.id, nextMonth, followingMonthEnd, tz, options(nextMonth))),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

export const fetchTransactionLineItems = ({ orderData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const getTransactionBetweenUsers = async (sdk, userAId, userBId) => {

  const fetchAllTransactionsForUser = async (userId) => {
    let allTxs = [];

    allTxs = await manualTransactions({ userId, type: 'fetch' });

    return allTxs;
  };

  const userATxs = await fetchAllTransactionsForUser(userAId);
  const userBTxs = await fetchAllTransactionsForUser(userBId);

  const allTxs = [...userATxs, ...userBTxs];
  const matchingTx = allTxs.find(tx => {

    const providerId = tx?.provider?.id;
    const customerId = tx?.customer?.id;

    return (
      (providerId === userAId && customerId === userBId) ||
      (providerId === userBId && customerId === userAId)
    );
  });

  if (matchingTx) {
    return matchingTx.id.uuid;
  } else {
    return '';
  }
};

export const getManualTransactionsBtwUsers = async (sdk, dispatch, customerId, providerId, listingId, txType = 'message') => {
  dispatch(getManualTxnBtwUsersRequest());

  try {
    let txns = {};

    if (txType === 'message') {
      txns = await conversations({ actionType: 'getOrCreate', senderId: customerId, receiverId: providerId });
      txns = txns ? [txns] : [];
    } else {
      txns = await manualTransactions({ customerId, providerId, listingId, txType, type: 'fetch' });
    }

    dispatch(getManualTxnBtwUsersSuccess(txns));
    return txns || [];
  } catch (error) {
    dispatch(getManualTxnBtwUsersError(storableError(error)));
    return null;
  }
};

export const fetchIntegrityCheckStatus = (candidateListingId) => async (dispatch) => {
  dispatch({ type: CHECK_INTEGRITY_STATUS_REQUEST });
  try {
    const response = await checkCustomerIntegrityCheckStatus(candidateListingId);
    dispatch({ type: CHECK_INTEGRITY_STATUS_SUCCESS, payload: response });
    return response;
  } catch (e) {
    dispatch({ type: CHECK_INTEGRITY_STATUS_ERROR, payload: storableError(e) });
    return null;
  }
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  dispatch(setLoadingState(true));
  const listingId = new UUID(params.id);
  dispatch(showListingRequest(listingId));
  dispatch(clearListingLinkPages());
  const state = getState();
  const currentUser = state?.user?.currentUser;
  const inquiryModalOpenForListingId =
    isUserAuthorized(currentUser) && hasPermissionToInitiateTransactions(currentUser)
      ? state.ListingPage.inquiryModalOpenForListingId
      : null;

  // Clear old line-items
  dispatch(setInitialValues({ lineItems: null, inquiryModalOpenForListingId }));

  const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];
  if (ownListingVariants.includes(params.variant)) {
    return dispatch(showListing(listingId, config, true));
  }

  // In private marketplace mode, this page won't fetch data if the user is unauthorized
  const isAuthorized = currentUser && isUserAuthorized(currentUser);
  const isPrivateMarketplace = config.accessControl.marketplace.private === true;
  const canFetchData = !isPrivateMarketplace || (isPrivateMarketplace && isAuthorized);
  if (!canFetchData) {
    return Promise.resolve();
  }

  const hasNoViewingRights = currentUser && !hasPermissionToViewData(currentUser);
  const promises = hasNoViewingRights
    ? // If user has no viewing rights, only allow fetching their own listing without reviews
    [await dispatch(showListing(listingId, config, true))]
    : // For users with viewing rights, fetch the listing and the associated reviews
    [await dispatch(showListing(listingId, config)), dispatch(fetchReviews(listingId))];

  return Promise.all(promises).then(async response => {
    const listingResponse = response[0];
    const listing = listingResponse?.data?.data;

    // A tab that already entered this sharing link's code keeps its share visit, so a refresh
    // loads what the visitor saw right after entering it.
    const keptShareVisit = shareVisitFromSearch(search);

    // Non-logged-in users only need the listing + reviews (already fetched above).
    // Skip all user-specific operations (transactions, profile, persona, etc.).
    if (!currentUser) {
      if (keptShareVisit) {
        dispatch(fetchShareVisitorPersonaRecords(listing?.id?.uuid, keptShareVisit));
        dispatch(fetchLinkedContactsForShareViewer());
      }
      dispatch(setLoadingState(false));
      return response;
    }

    const listingAdminId = listing?.attributes?.publicData?.adminId;

    let txId = '';

    const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId || currentUser?.attributes?.profile?.publicData?.firstListingId;
    // A user who has not created a profile listing yet has none to load, and a failed lookup leaves
    // the page without the viewer's profile rather than failing the whole page load.
    let currentUserListing = null;
    if (profileListingId) {
      try {
        const profileListingResponse = await sdk.listings.show({ id: profileListingId });
        currentUserListing = profileListingResponse?.data?.data || null;
      } catch (e) {
        currentUserListing = null;
      }
    }
    const currentUserAdminId = currentUserListing?.attributes?.publicData?.adminId;

    // Conversations and applications are between main accounts, so without one there are none to load.
    if (currentUserAdminId && listingAdminId !== currentUserAdminId) {

      const manualMsgTxns = await getManualTransactionsBtwUsers(sdk, dispatch, currentUserAdminId, listingAdminId, listingId, 'message');

      if (Array.isArray(manualMsgTxns) && manualMsgTxns?.length > 0) {
        txId = manualMsgTxns[0]?.transactionId;
        dispatch(setMessageTxnId(txId));
      }

      if (!txId && currentUserAdminId && listingAdminId) {
        try {
          const existingConv = await conversations({ actionType: 'get', senderId: currentUserAdminId, receiverId: listingAdminId });
          if (existingConv?.conversationId) {
            dispatch(setMessageTxnId(existingConv.conversationId));
          }
        } catch (e) {
          // non-fatal: fall through to show modal on click
        }
      }

      const manualApplyTxns = await getManualTransactionsBtwUsers(sdk, dispatch, currentUserAdminId, listingAdminId, listingId, 'apply');

      if (Array.isArray(manualApplyTxns) && manualApplyTxns?.length > 0) {
        const applyTxnId = manualApplyTxns[0]?.transactionId;
        dispatch(setApplyTxnId(applyTxnId));
        const manualTxn = manualApplyTxns[0];
        const showMessageButton = manualTxn?.status && manualTxn?.status !== 'rejected';
        dispatch(setEnableMessageButton(showMessageButton));
      }

    }

    dispatch(setMainUserId(currentUserAdminId));
    // The viewer's own wallet records are in their listing's private data, which the public read
    // above does not return; their own screens read them from the stored listing.
    dispatch(setProfileListing(await withOwnPrivateData(currentUserListing, profileListingId)));
    dispatch(
      keptShareVisit
        ? fetchShareVisitorPersonaRecords(listing?.id?.uuid, keptShareVisit)
        : fetchUserPersonaRecords(listing?.id?.uuid)
    );

    // Fetch author email
    const listingAuthorId = listing?.relationships?.author?.data?.id?.uuid;
    if (listingAuthorId) {
      dispatch(fetchAuthorEmail(listingAuthorId, listing?.id?.uuid));
    }

    // A listing's type lives in its public data; a job or RFP listing has no linked contacts of its own.
    const viewedListingType = listing?.attributes?.publicData?.listingType;
    if (viewedListingType !== 'job_listing' && viewedListingType !== 'rfp_listing') {
      const issuerId = listing?.relationships?.author?.data?.id?.uuid;
      dispatch(fetchProofRequestRecords(currentUser.id.uuid, issuerId));

      // Fetch linked consultants/recruiters based on listing type
      const listingType = listing?.attributes?.publicData?.listingType;
      if (listingAuthorId) {
        dispatch(fetchListingLinkPages(listingAuthorId, listingType, listing?.id?.uuid));
      }
    }

    // Check integrity check status for customers viewing candidate listings
    const currentUserType = userTypeOf(currentUser);
    const listingType = listing?.attributes?.publicData?.listingType;
    if (currentUserType === 'customer' && listingType === 'candidate') {
      const candidateListingId =
        listing?.attributes?.publicData?.firstListingId ||
        listing?.attributes?.publicData?.profileListingId ||
        listing?.id?.uuid;
      dispatch(fetchIntegrityCheckStatus(candidateListingId));
    }

    dispatch(setLoadingState(false));

    return response;
  });
};

export const initiateApplyTransaction = (listingId, acceptingInvitation = false, consultantId = '', consultantListingId = '', appliedByAgency = false, identityDocuments = [], workAuthorizationDocuments = [], applicationResume = null, status = null, pendingCandidateId = null, pendingCandidateInfo = null, consentId = null) => async (dispatch, getState, sdk) => {
  dispatch(initiateApplyTransactionRequest());

  let listing;
  try {
    const listingResponse = await showPostingListing(sdk, {
      id: listingId,
      include: ['author', 'author.profileImage', 'images', 'currentStock'],
    });
    listing = listingResponse?.data?.data;
  } catch (e) {
    dispatch(initiateApplyTransactionError(storableError(e)));
    throw e;
  }

  const currentUser = getState().user.currentUser;

  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId || currentUser?.attributes?.profile?.publicData?.firstListingId;
  // A user who has not created a profile listing yet has none to load.
  let profileListing = null;
  if (profileListingId) {
    try {
      const profileListingResponse = await sdk.listings.show({ id: profileListingId });
      profileListing = profileListingResponse?.data?.data || null;
    } catch (e) {
      profileListing = null;
    }
  }

  const currentUserAdminId = profileListing?.attributes?.publicData?.adminId;

  // The applicant is the viewer's main account, found through their profile listing. An agency
  // applying for an existing consultant applies as that consultant, so it needs no profile of its own.
  const appliesAsConsultant = appliedByAgency && !!consultantId && !pendingCandidateId;
  if (!currentUserAdminId && !appliesAsConsultant) {
    const err = new Error('Create your profile before applying.');
    dispatch(initiateApplyTransactionError(storableError(err)));
    throw err;
  }

  const currentListingAdminId = listing?.attributes?.publicData?.adminId;
  const isJobApplication = listing?.attributes?.publicData?.listingType === 'job_listing';

  const profileResumeUrl =
    currentUser?.attributes?.profile?.publicData?.resumeUrl ||
    profileListing?.attributes?.publicData?.resumeUrl ||
    '';
  const profileResumeName =
    currentUser?.attributes?.profile?.publicData?.resumeName ||
    profileListing?.attributes?.publicData?.resumeName ||
    '';
  const profileResumeUploadedAt =
    currentUser?.attributes?.profile?.publicData?.resumeUploadedAt ||
    profileListing?.attributes?.publicData?.resumeUploadedAt ||
    null;

  const selectedApplicationResume = applicationResume?.url
    ? {
      url: applicationResume.url,
      name: applicationResume.name || 'Resume',
      blobName: applicationResume.blobName || '',
      uploadedAt: applicationResume.uploadedAt || new Date().toISOString(),
      source: applicationResume.source || 'applicationUpload',
    }
    : profileResumeUrl
      ? {
        url: profileResumeUrl,
        name: profileResumeName || 'Profile Resume',
        blobName: '',
        uploadedAt: profileResumeUploadedAt,
        source: 'profileResume',
      }
      : null;

  if (isJobApplication && !appliedByAgency && !selectedApplicationResume?.url) {
    const err = new Error('A resume is required to apply for this job.');
    dispatch(initiateApplyTransactionError(storableError(err)));
    throw err;
  }

  // New-candidate on-behalf apply: no Sharetribe candidate user/listing exists yet.
  // The agency stands in as userA/customer until the candidate activates.
  const isPendingNewCandidate = appliedByAgency && !!pendingCandidateId;

  let toSendPayload = {
    userAId: appliedByAgency && !isPendingNewCandidate ? consultantId : currentUserAdminId,
    userBId: currentListingAdminId,
    providerId: currentListingAdminId,
    customerId: appliedByAgency && !isPendingNewCandidate ? consultantId : currentUserAdminId,
    listingId: listingId,
    metadata: {},
    txType: 'apply',
    type: 'create',
    ...(status ? { status } : {}),
  };

  if (acceptingInvitation) {
    toSendPayload.metadata.acceptedInvitation = true;
  }

  if (isJobApplication && selectedApplicationResume?.url) {
    toSendPayload.metadata.applicationResume = {
      url: selectedApplicationResume.url,
      name: selectedApplicationResume.name,
      blobName: selectedApplicationResume.blobName || '',
      uploadedAt: selectedApplicationResume.uploadedAt || null,
      source: selectedApplicationResume.source || 'profileResume',
    };
  }

  if (appliedByAgency && consultantId) {
    toSendPayload.appliedByAgency = true;
    toSendPayload.consultantAdminId = consultantId;
    toSendPayload.consultantListingId = consultantListingId;
    toSendPayload.agencyListingId = profileListingId;
  }

  if (isPendingNewCandidate) {
    toSendPayload.appliedByAgency = true;
    toSendPayload.agencyListingId = profileListingId;
    toSendPayload.pendingCandidateId = pendingCandidateId;
    toSendPayload.pendingCandidateEmail = pendingCandidateInfo?.email || '';
    // Stored on the tx so the job poster's placeholder card can render the
    // candidate's name/agency without a Sharetribe profile to resolve.
    toSendPayload.pendingCandidateFirstName = pendingCandidateInfo?.firstName || '';
    toSendPayload.pendingCandidateLastName = pendingCandidateInfo?.lastName || '';
    toSendPayload.pendingCandidateAgencyName = pendingCandidateInfo?.agencyName || '';
    toSendPayload.activationStatus = 'pending';
  }
  // Add document URLs to metadata if provided
  if (identityDocuments && identityDocuments.length > 0) {
    toSendPayload.metadata.identityDocuments = identityDocuments.map(doc => ({
      url: doc.url,
      name: doc.name,
      blobName: doc.blobName,
      uploadedAt: doc.uploadedAt || new Date().toISOString(),
    }));
  }

  if (workAuthorizationDocuments && workAuthorizationDocuments.length > 0) {
    toSendPayload.metadata.workAuthorizationDocuments = workAuthorizationDocuments.map(doc => ({
      url: doc.url,
      name: doc.name,
      blobName: doc.blobName,
      uploadedAt: doc.uploadedAt || new Date().toISOString(),
    }));
  }
  // The saved upload consent the server checks before it accepts the uploaded documents.
  if (consentId) {
    toSendPayload.consentId = consentId;
  }
  return manualTransactions(toSendPayload)
    .then(async response => {

      const { transactionId } = response;
      dispatch(setApplyTxnId(transactionId));

      try {
        dispatch(updateApplierProfileRequest());

        let jobListing = await showPostingListing(sdk, { id: listingId });
        jobListing = jobListing?.data?.data;

        if (jobListing?.attributes?.publicData?.listingType === 'rfp_listing') {
          const currentCount = profileListing?.attributes?.publicData?.freeRFPApplicationsUsed?.count;
          let newCount = (currentCount || 0) + 1;
          const rfpFreeApplicationsStartedAt = profileListing?.attributes?.publicData?.freeRFPApplicationsUsed?.startedAt ? new Date(profileListing?.attributes?.publicData?.freeRFPApplicationsUsed?.startedAt) : null;
          let rfpFreeCountPeriodExpired = false;

          // Get subscription information from user's protected data
          const subscriptionsOfUser = currentUser?.attributes?.profile?.protectedData?.subscriptionsOfUser || [];
          const subscription = subscriptionsOfUser[0];
          const subscriptionType = subscription?.type;

          // Determine if user has monthly or yearly plan
          const isMonthlyPlan = subscriptionType === 'verified-plus-delivery-vendor-monthly';
          const isYearlyPlan = subscriptionType === 'verified-plus-delivery-vendor-yearly';

          if (rfpFreeApplicationsStartedAt) {
            const startedDate = rfpFreeApplicationsStartedAt;
            const now = new Date();

            // Calculate difference in milliseconds
            const diffInMs = now - startedDate;

            if (isMonthlyPlan) {
              // For monthly plans: check if 30 days have passed
              const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
              if (diffInDays >= 30) {
                rfpFreeCountPeriodExpired = true;
                newCount = 1;
              }
            } else if (isYearlyPlan) {
              // For yearly plans: check if 1 year has passed
              const diffInYears = diffInMs / (1000 * 60 * 60 * 24 * 365);
              if (diffInYears >= 1) {
                rfpFreeCountPeriodExpired = true;
                newCount = 1;
              }
            }
          }

          await createNewListing({ profileListingId, count: newCount, updateFreeRFPApplicationsCount: true, rfpFreeCountStartedOneYearAgo: rfpFreeCountPeriodExpired });

          // Fetch the updated profile listing and update Redux store
          let updatedProfileListing = await sdk.listings.show({ id: profileListingId });
          updatedProfileListing = updatedProfileListing?.data?.data;
          dispatch(setProfileListing(await withOwnPrivateData(updatedProfileListing, profileListingId)));
        }

        const noOfApplications = jobListing?.attributes?.publicData?.noOfApplications || 0;

        try {
          dispatch(updateAppliedListingRequest());

          if (isPendingNewCandidate) {
            // No profile-listing id yet — record a placeholder pendingApplier instead.
            // Drained into appliers when the candidate activates.
            const existingPending = jobListing?.attributes?.publicData?.pendingAppliers || [];
            const newPendingAppliers = [
              ...existingPending,
              {
                pendingCandidateId,
                firstName: pendingCandidateInfo?.firstName || '',
                lastName: pendingCandidateInfo?.lastName || '',
                email: pendingCandidateInfo?.email || '',
                agencyListingId: profileListingId,
                agencyName: pendingCandidateInfo?.agencyName || '',
                appliedAt: new Date().toISOString(),
              },
            ];

            await createNewListing({ jobListingId: listingId, noOfApplications: noOfApplications + 1, updatePendingAppliers: true, pendingAppliers: newPendingAppliers });
          } else {
            let allAppliers = jobListing?.attributes?.publicData?.appliers || [];
            const applierListingId = appliedByAgency ? consultantListingId : currentUser?.attributes?.profile?.publicData?.profileListingId;
            allAppliers = [...(allAppliers || []), applierListingId];

            await createNewListing({ jobListingId: listingId, noOfApplications: noOfApplications + 1, updateNoOfApplications: true, appliers: allAppliers });
          }

          dispatch(updateAppliedListingSuccess());

        } catch (error) {
          dispatch(updateAppliedListingError(storableError(error)));
        }

        dispatch(updateApplierProfileSuccess());

      } catch (error) {
        dispatch(updateApplierProfileError(storableError(error)));
      }

      dispatch(initiateApplyTransactionSuccess());
    })
    .catch(e => {
      dispatch(initiateApplyTransactionError(storableError(e)));
      throw e;
    });
};

export const initiateManualTransaction = (message, listingId, applying = false, messaging = false, acceptingInvitation = false) => async (dispatch, getState, sdk) => {
  dispatch(initiateManualTxnRequest());

  // const { message, listingId, applying=false, messaging=false, acceptingInvitation=false, } = actionPayload;

  const currentUser = getState().user.currentUser;
  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId || currentUser?.attributes?.profile?.publicData?.firstListingId;

  // The sender is the viewer's main account, found through their profile listing, so a viewer
  // without one has no one to send as. Callers read `false` as nothing sent.
  let listing;
  let profileListing;
  try {
    if (!profileListingId) throw new Error('Create your profile before applying or sending a message.');
    const [listingResponse, profileListingResponse] = await Promise.all([
      showPostingListing(sdk, { id: listingId }),
      sdk.listings.show({ id: profileListingId }),
    ]);
    listing = listingResponse?.data?.data;
    profileListing = profileListingResponse?.data?.data;
  } catch (e) {
    dispatch(initiateManualTxnError(storableError(e)));
    return false;
  }

  const currentListingAdminId = listing?.attributes?.publicData?.adminId;
  const currentUserAdminId = profileListing?.attributes?.publicData?.adminId;

  let toSendPayload = {
    userAId: currentUserAdminId,
    userBId: currentListingAdminId,
    providerId: currentListingAdminId,
    customerId: currentUserAdminId,
    listingId: listingId,
    metadata: {},
    type: 'create',
  };

  if (applying) {
    toSendPayload.txType = 'apply';
    return manualTransactions(toSendPayload)
      .then(res => {
        dispatch(initiateManualTxnSuccess(res?.transactionId));
        return res?.transactionId;
      })
      .catch(err => {
        dispatch(initiateManualTxnError(storableError(err)));
        return false;
      });
  } else if (messaging) {
    try {
      dispatch(sendManualMessageRequest());
      const conv = await conversations({ actionType: 'getOrCreate', senderId: currentUserAdminId, receiverId: currentListingAdminId });
      const conversationId = conv?.conversationId;

      // A message from a job or RFP page names that posting; the server keeps it only for the
      // company's own posting the sender may read, so the company sees what the question is about.
      const aboutPosting = isPostingData(listing?.attributes?.publicData) ? { postingId: listingId } : {};
      await chatMessages({
        actionType: 'send',
        conversationId,
        senderId: currentUserAdminId,
        receiverId: currentListingAdminId,
        text: message,
        attachments: [],
        ...aboutPosting,
      });

      dispatch(sendManualMessageSuccess());
      dispatch(initiateManualTxnSuccess(conversationId));
      return conversationId;
    } catch (err) {
      dispatch(sendManualMessageError(storableError(err)));
      dispatch(initiateManualTxnError(storableError(err)));
      return false;
    }
  }

  return manualTransactions(toSendPayload)
    .then(res => {
      dispatch(initiateManualTxnSuccess(res?.transactionId));
      return res?.transactionId;
    })
    .catch(err => {
      dispatch(initiateManualTxnError(storableError(err)));
      return false;
    });
};

export const fetchAllCandidatesListings = (ids) => async (dispatch, getState, sdk) => {
  dispatch(getAllCandidatesListingsRequest());

  // If an empty array is passed, no candidates to resolve — skip API call
  if (Array.isArray(ids) && ids.length === 0) {
    dispatch(getAllCandidatesListingsSuccess([]));
    return;
  }

  return getListingsByIds({ ids, listingType: 'candidate', listingPage: true })
    .then(res => {
      const response = res.data.data;
      dispatch(getAllCandidatesListingsSuccess(response));
      return res;
    })
    .catch(e => {
      dispatch(getAllCandidatesListingsError(storableError(e)));
      throw e;
    });
};

export const requestDocumentPresentation = (data) => async (dispatch, getState, sdk) => {
  dispatch(requestDocumentPresentationRequest());

  return requestDocPresentation(data)
    .then(res => {
      const response = res.data.data;
      dispatch(requestDocumentPresentationSuccess(response));
      return res;
    })
    .catch(e => {
      dispatch(requestDocumentPresentationError(storableError(e)));
      throw e;
    });
};

export const fetchProofRequestRecords = (verifierId, issuerId) => async (dispatch, getState, sdk) => {
  dispatch(fetchRequestRecordsRequest());

  return fetchRequestRecords({ verifierId, issuerId, type: 'fetch' })
    .then(res => {
      const requestRecords = res;
      dispatch(fetchRequestRecordsSuccess(requestRecords));
      return res;
    })
    .catch(e => {
      dispatch(fetchRequestRecordsError(storableError(e)));
      throw e;
    });
};

// How many links of each list the listing page shows at once: cards and linked partners 6, the
// partner tables 10.
export const LISTING_LINK_PAGE_SIZES = {
  recruiters: 6,
  staffingConsultants: 6,
  implementationConsultants: 6,
  staffingVendors: 6,
  implementationVendors: 6,
  staffingCustomers: 10,
  implementationCustomers: 10,
  staffingSubSuppliers: 6,
  implementationSubSuppliers: 6,
};

// The lists a profile shows, by the type of its listing: a candidate's linked partners, an agency's
// consultants, partners and its own sub-suppliers, a company's consultants and preferred vendors.
const LISTING_LINK_LISTS = {
  candidate: ['recruiters'],
  agency: [
    'staffingConsultants',
    'implementationConsultants',
    'staffingCustomers',
    'implementationCustomers',
    'staffingSubSuppliers',
    'implementationSubSuppliers',
  ],
  customer: ['staffingConsultants', 'implementationConsultants', 'staffingVendors', 'implementationVendors'],
};

const CONSULTANT_LISTS = ['staffingConsultants', 'implementationConsultants'];

/**
 * Reads one page of one of the listing owner's link lists, then the candidate profiles of the
 * consultants on it, which their cards show. A page that fails is recorded as failed; this never
 * throws.
 */
export const fetchListingLinkPage = ({ list, page, ownerId, listingId }) => async dispatch => {
  const shown = await dispatch(
    fetchLinkPage({
      scope: 'listing',
      list,
      ownerId,
      page,
      perPage: LISTING_LINK_PAGE_SIZES[list],
      listingId,
      listingPage: true,
    })
  );
  if (CONSULTANT_LISTS.includes(list) && shown?.status === 'loaded') {
    const candidateIds = [...new Set(shown.items.map(c => c.listingId).filter(Boolean))];
    if (candidateIds.length) {
      try {
        await dispatch(fetchAllCandidatesListings(candidateIds));
      } catch (e) {
        // Already recorded as the candidate listings error; the cards show without profiles.
      }
    }
  }
  return shown;
};

// Reads the first page of each list the profile shows. A job or RFP listing shows none.
export const fetchListingLinkPages = (authorId, listingType, listingId) => async dispatch => {
  const lists = LISTING_LINK_LISTS[listingType] || [];
  await Promise.all(
    lists.map(list => dispatch(fetchListingLinkPage({ list, page: 1, ownerId: authorId, listingId })))
  );
};

export const fetchAuthorEmail = (authorId, listingId) => async (dispatch, getState, sdk) => {
  dispatch(fetchUserEmailRequest());

  return getUserEmail({ userId: authorId, listingId })
    .then(res => {
      const email = res?.data?.email;
      dispatch(fetchUserEmailSuccess(email));
      return email;
    })
    .catch(e => {
      dispatch(fetchUserEmailError(storableError(e)));
      throw e;
    });
};

// Share Profile Thunks
export const requestShareOtpDuck = (token) => async (dispatch, getState, sdk) => {
  dispatch(requestShareOtpRequest());

  return requestShareOtp({ token })
    .then(res => {
      dispatch(requestShareOtpSuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(requestShareOtpError(storableError(e)));
      throw e;
    });
};

// A signed-out visitor's page skips linked contacts when it loads; a verified share-link visitor is
// shown those sections, so load their first pages once the code is accepted. A page that fails is
// marked failed and never fails the verification.
export const fetchLinkedContactsForShareViewer = () => async (dispatch, getState) => {
  const state = getState();
  const listingId = state.ListingPage?.id?.uuid;
  const listing = listingId ? state.marketplaceData?.entities?.listing?.[listingId] : null;
  const authorId = listing?.relationships?.author?.data?.id?.uuid;
  const listingType = listing?.attributes?.publicData?.listingType;
  if (!authorId || listingType === 'job_listing' || listingType === 'rfp_listing') {
    return;
  }
  await dispatch(fetchListingLinkPages(authorId, listingType, listingId));
};

export const verifyShareOtpDuck = (token, otp) => async (dispatch, getState, sdk) => {
  dispatch(verifyShareOtpRequest());

  return verifyShareOtp({ token, otp })
    .then(res => {
      dispatch(verifyShareOtpSuccess(res));
      if (res?.verified && !getState().user?.currentUser) {
        dispatch(fetchLinkedContactsForShareViewer());
      }
      return res;
    })
    .catch(e => {
      dispatch(verifyShareOtpError(storableError(e)));
      const thrownError = {};
      if (e.error) thrownError.error = e.error;
      if (e.remainingAttempts !== undefined) thrownError.remainingAttempts = e.remainingAttempts;
      throw thrownError;
    });
};

// The share visit this tab keeps for the sharing link in the page address, or null.
const shareVisitFromSearch = search => {
  try {
    const token = new URLSearchParams(search || '').get('share');
    return readShareVisit(token)?.shareVisit || null;
  } catch (e) {
    return null;
  }
};

// A share visitor's view of the profile's verification records: sent with the visit, the server
// recognises them as a visitor the owner shared the profile with. A failed lookup leaves the page's
// records as they were.
export const fetchShareVisitorPersonaRecords = (profileListingId, shareVisit) => async dispatch => {
  if (!profileListingId || !shareVisit) return null;
  try {
    const res = await fetchPersonaRecords({ profileListingId }, { shareVisit });
    if (res?.success && res.data) {
      dispatch(fetchPersonaRecordsSuccess(res.data));
      return res.data;
    }
  } catch (e) {
    // Non-fatal: the page keeps what it has.
  }
  return null;
};

// `options.shareVisit` ({ token, session }) is the visit this tab was given for the link.
export const getSharedProfileDuck = (token, options) => async (dispatch, getState, sdk) => {
  dispatch(getSharedProfileRequest());

  return getSharedProfile({ token }, options)
    .then(res => {
      dispatch(getSharedProfileSuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(getSharedProfileError(storableError(e)));
      throw e;
    });
};

export const payForRFPDuck = (priceId, quantity, type, rfpPageLink) => async (dispatch, getState, sdk) => {
  dispatch(payForRFPRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListing = state.user?.profileListing;

  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
    currentUser?.attributes?.profile?.publicData?.firstListingId;

  let email = null;
  let adminId = '';

  if (!profileListingId) {
    return;
  }

  if (userTypeOf(currentUser) === 'candidate') {
    adminId = currentUser?.id?.uuid;
    email = currentUser?.attributes?.email;
  } else {
    // let profileListing = await sdk.listings.show({ id: profileListingId });
    // profileListing = profileListing?.data?.data;

    email = currentUser?.attributes?.email;

    adminId = profileListing?.attributes?.publicData?.adminId;
    // if (adminId) {
    //   const adminUserResponse = await getUserDetails({ userId: adminId });
    //   const adminUser = adminUserResponse?.data?.data;
    //   email = adminUser?.attributes?.email;
    // }
  }

  if (!email) {
    return;
  }

  return createCheckoutSession({ priceId, quantity, type, email, paidBy: adminId, isRFPApplicationPage: true, rfpPageLink: rfpPageLink })
    .then(async response => {

      dispatch(payForRFPSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(payForRFPError(storableError(e)));
      throw e;
    });
};

export const saveRFPPayments = (sessionId) => async (dispatch, getState, sdk) => {
  dispatch(saveRFPPaymentRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListing = state.user?.profileListing;

  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
    currentUser?.attributes?.profile?.publicData?.firstListingId;

  let email = null;
  let adminId = '';

  if (!profileListingId) {
    return;
  }

  if (userTypeOf(currentUser) === 'candidate') {
    adminId = currentUser?.id?.uuid;
    email = currentUser?.attributes?.email;
  } else {
    adminId = profileListing?.attributes?.publicData?.adminId;
    email = currentUser?.attributes?.email;
  }

  if (!email) {
    return;
  }

  return saveRFPPayments({ actionType: 'create', sessionId: sessionId, userId: adminId, profileListingId: profileListingId })
    .then(response => {
      dispatch(saveRFPPaymentSuccess(response));
      return true;
    })
    .catch(err => {
      dispatch(saveRFPPaymentError(err));
      return false;
    });
};

export const requestProfileAccessDuck = (requestData) => async (dispatch, getState, sdk) => {
  dispatch(requestProfileAccessRequest());

  return requestProfileAccess(requestData)
    .then(res => {
      dispatch(requestProfileAccessSuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(requestProfileAccessError(storableError(e)));
      throw e;
    });
};

export const fetchJobConsent = (consentType, jobListingId) => (dispatch) => {
  dispatch(fetchJobConsentRequest());

  return fetchConsent({ consentType, jobListingId })
    .then(response => {
      const hasConsent = Boolean(response?.hasConsent);
      dispatch(fetchJobConsentSuccess(hasConsent));
      return response;
    })
    .catch(e => {
      dispatch(fetchJobConsentError(storableError(e)));
      throw e;
    });
};

export const updateTransactionDocuments = (transactionId, metadata, options = {}) => (dispatch) => {
  dispatch(updateTransactionDocumentsRequest());

  return updateTransactionMetadata({ transactionId, metadata, ...options })
    .then(response => {
      dispatch(updateTransactionDocumentsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(updateTransactionDocumentsError(storableError(e)));
      throw e;
    });
};

/**
 * Share credential with a recipient via email
 * @param {Object} shareData - Share credential data
 * @param {string} shareData.credentialId - Dock credential ID
 * @param {string} shareData.password - Credential password
 * @param {string} shareData.documentType - Document type
 * @param {string} shareData.recipientEmail - Recipient email
 * @param {string} shareData.issuerId - User ID of issuer
 * @param {string} shareData.issuerName - Name of issuer
 * @param {string} shareData.issuerEmail - Email of issuer
 * @param {string} shareData.userDid - Optional user DID
 * @returns {Promise} Share response with shareId and presentationUrl
 */
export const shareCredentialDuck = (shareData) => async (dispatch, getState, sdk) => {
  // The consent is kept out of the payload the submission key is matched on, so a retry with a
  // freshly saved consent is still the same submission.
  const { consentId, ...payload } = shareData;
  return keyedSubmission('direct-share', payload, body => shareCredential({ ...body, consentId }))
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
};

// ==========================================
// Credential Access Request Ducks (credentialVault-based, replaces Truvera/Dock flow)
// ==========================================

/**
 * Request access to another user's credentials via credentialVault
 */
export const requestCredentialAccessDuck = (requestData) => async (dispatch, getState, sdk) => {
  // The consent is kept out of the payload the submission key is matched on, so a retry with a
  // freshly saved consent is still the same submission.
  const { consentId, ...payload } = requestData;
  return keyedSubmission('credential-request', payload, body => requestCredentialAccess({ ...body, consentId }))
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
};

/**
 * Fetch credential access requests for a profile listing
 */
export const getCredentialAccessRequestsDuck = (params) => async (dispatch, getState, sdk) => {
  return getCredentialAccessRequests(params)
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
};

/**
 * Approve a credential access request - fetches from vault and sends share link.
 * `files` are the requested company files the approver ticked; only those are shared.
 * `consentId` is the share consent the approver saved for this approval.
 */
export const approveCredentialAccessDuck = (requestId, files = [], consentId = null) => async (dispatch, getState, sdk) => {
  return approveCredentialAccess(approvalPayload(requestId, files, consentId))
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
};

/**
 * Send an approved request's email again, when the approval answered that it did not go.
 */
export const resendCredentialAccessEmailDuck = requestId => async (dispatch, getState, sdk) => {
  return resendCredentialAccessEmail({ requestId });
};

/**
 * Reject a credential access request
 */
export const rejectCredentialAccessDuck = (requestId) => async (dispatch, getState, sdk) => {
  return rejectCredentialAccess({ requestId })
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
};
